import { Typography, styled } from "@mui/material";

export { default as Button } from "./Button";
export { default as CustomDropDownInput } from "./CustomDropDownInput";
export { default as DropDown } from "./DropDown";
export { default as EmptyState } from "./EmptyState";
export { default as FilterButton } from "./FilterButton";
export { default as FormDropDown } from "./FormDropDown";
export { default as PassingCriteriaDialog } from "./PassingCriteriaDialog";
export { default as CustomDatePicker } from "./CustomDatePicker";
export { default as FormInput } from "./FormInput";
export { default as Tooltip } from './Tooltip';
export { default as FormPhoneInput } from "./FormPhoneInput";
export { default as GridListView } from "./GridListView";
export { default as Input } from "./Input";
export { default as PostPreviewCard } from './PostPreviewCard';
export { default as LoaderPage } from "./LoaderPage";
export { default as Switch } from './Switch';
export { default as Pagination } from "./Pagination";
export { default as FilterDropDown } from "./FilterDropDown";
export { default as CustomSlider } from './CustomSlider';
export { default as TableLoading } from "./TableLoading";
export { default as QuillInput } from "./QuillInput";
export { default as ResponsiveTabs } from './ResponsiveTabs';
export { default as SearchInput } from "./SearchInput";
export { default as ColorPickerButton } from './ColorPickerButton';
export { default as PlanDropDown } from './PlanDropDown';
export { default as TableListView } from "./TableListView";
export { default as QnaRating } from './QnaRating';
export { default as TextArea } from "./TextArea";

export const GradientText = styled(Typography)(() => ({
  background: "linear-gradient(to right, #63C2F8, #9048FB)",
  "-webkit-background-clip": "text",
  "-webkit-text-fill-color": "transparent",
}));
